///<reference path="../../../../components/common/identity.service.ts"/>
///<reference path="../../../../components/common/security.service.ts"/>
///<reference path="../../../../components/common/security.keys.ts"/>
///<reference path="../../../../components/baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../components/baseClasses/dataServiceBase.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>
///<reference path="../../../../components/modal/modal.interface.ts"/>
///<reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {
   
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    class MeevoReportMsg01Component implements angular.IComponentController {

        static $inject = [
            '$q',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            'meevo.components.common.SecurityService',
            'meevo.components.busy.BusyService'
        ];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: SecurityAccessEnum;
        public options: Model.IReportControl;
        public form: ng.IFormController;
        public criteria: any;

 
        private _billingPeriodSelectList: any[] = [];
        private _selectedDate: any;
       
        get billingPeriodSelectList(): any[] {
            return this._billingPeriodSelectList;
        }

        get selectedRange(): any {
            if (this._selectedDate) {
                return this._selectedDate;
            }
        }

        set selectedRange(value:any) {
            this._selectedDate = value;            
            this.mainModel["BillingStartDate"] = value.startDate;
            this.mainModel["BillingEndDate"] = value.endDate;
        }

        constructor(private $q: angular.IQService,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private identityService: Meevo.Components.Common.IdentityService,
                    private securityService: Meevo.Components.Common.ISecurityService,
                    protected busyService: Meevo.Components.Busy.IBusyService) {
            this.criteria = {};
        }

        private loadBillingPeriod(): angular.IPromise<any> {
            this._billingPeriodSelectList = [];

            //API call to get billing date range
            return this.dataService.customMethodData(`api/Location/${this.identityService.locationId}`, "GET", null)
                .then((response) => {
                    var location: Meevo.Model.Location = response.data;
                    if (location) {
                        if (location.billDay == 0) {
                            location.billDay = 1;
                        }
                        // create the starting date using current month and year, and using the
                        var currentDate = moment().endOf('day');
                        var startDate = moment(new Date(currentDate.year(), currentDate.month(), location.billDay, 0, 0, 0, 0));
                        var endDate = moment(startDate.format()).endOf("day");
                        endDate.add({ months: 1 });
                        if (currentDate.isAfter(startDate)) {
                            // add today up to endDate
                            this._billingPeriodSelectList.push({ startDate: new Date(startDate.toDate().valueOf()), endDate: new Date(currentDate.toDate().valueOf()) });
                            startDate.subtract({ months: 1 });
                            endDate.subtract({ months: 1 })
                        }
                        else if (currentDate.isBefore(startDate)) {
                            startDate.subtract({ months: 1 });
                            endDate.subtract({ months: 1 })
                            this._billingPeriodSelectList.push({ startDate: new Date(startDate.toDate().valueOf()), endDate: new Date(currentDate.toDate().valueOf()) });
                            startDate.subtract({ months: 1 });
                            endDate.subtract({ months: 1 })
                        }

                        // set the end of all billing period (in the past), based on either the subscriptionActivationDate or one year from today, whichever is later
                        var billingStart = moment().subtract("years", 1).startOf("day");
                        var subscriptionDate: moment.Moment;
                        if (location.subscriptionActivationDate) {
                            subscriptionDate = moment(location.subscriptionActivationDate);
                            if (subscriptionDate.isAfter(billingStart)) {
                                billingStart = subscriptionDate.startOf("day");
                            }
                        }

                        // populate billingPeriodSelectList
                        while (!startDate.isBefore(billingStart)) {
                            endDate.subtract({ days: 1 });
                            this._billingPeriodSelectList.push({ startDate: new Date(startDate.toDate().valueOf()), endDate: new Date(endDate.toDate().valueOf()) });
                            endDate.add({ days: 1 });
                            startDate.subtract({ months: 1 });
                            endDate.subtract({ months: 1 });
                        }
                        // populate billingPeriodSelectList
                        if (startDate.isBefore(billingStart) && endDate.isAfter(billingStart)) {
                            endDate.subtract({ days: 1 });
                            this._billingPeriodSelectList.push({ startDate: new Date(billingStart.toDate().valueOf()), endDate: new Date(endDate.toDate().valueOf()) });
                            endDate.add({ days: 1 });
                        }
                    }
                });
        }

        getSmsCount(): angular.IPromise<any> {
            return this.dataService.customMethodData('/api/Settings/Location', 'GET', null).then((response) => {
                this.mainModel["SMSCount"] = response.data.maxNumberOfTextMessages;
            });
        }

        $onInit() {
            this.securityAccess = SecurityAccessEnum.Deny;
            this.securityService.checkSecurityKey(SecurityKeys.REPORTS_ANALYTICAL_MSG01)
                .then((permission: SecurityAccessEnum) => {
                    this.securityAccess = permission;
                });

            this.busyService.start()
            this.$q.all([
                this.getSmsCount(),
                this.loadBillingPeriod()
            ]).finally(() => {
                this.busyService.stop();
            });
        }

    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportMsg01Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/msg01/meevo-report-msg01.component.html',
            controller: MeevoReportMsg01Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                options: '<',
                form: '<',
            }
        });
}
